export default {"src":"/_next/static/media/pdf_icon.95379a85.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};